import { pushData, pushEvent } from '@nykaa/data-layer';
import {
  COUPON_APPLIED_MSG,
  PAGE_SOURCE_PARAM,
  PRODUCT_WIDGET_VALUE,
  PRODUCT_WIDGET_LABEL,
  SITE_NAVIGATION_PARAM,
  SITE_SUB_NAVIGATION_PARAM,
} from './constants';
import { BuyNowCtaClickedData, PAGE_TYPES, UpdatedTrackingKeys } from './types';
import { isConfigurable } from 'helpers/utils/product';
import { TRACKING } from 'components/SignUp/helper';

export const onScrollStickyInfo = () => {
  if (!document) {
    return;
  }
  const containerElement = document.querySelector('#stickElement');
  const topStickyElement = document.querySelector('#topSticky');
  if (containerElement && topStickyElement) {
    const offsetBottom = containerElement.getBoundingClientRect().bottom;
    const cartElementTop = topStickyElement.getBoundingClientRect().top;
    const cartElementHeight = topStickyElement.clientHeight;
    if (offsetBottom < cartElementTop + cartElementHeight) {
      topStickyElement.classList.add('top-sticky');
      topStickyElement.classList.add('sticky');
      topStickyElement.classList.remove('initial');
    } else {
      topStickyElement.classList.remove('sticky');
      topStickyElement.classList.remove('top-sticky');
      topStickyElement.classList.add('initial');
    }
  }
};

const getAppliedCouponText = (appliedCouponText: string) =>
  `Coupon - ${appliedCouponText} applied automatically to bag.`;

export const getCouponDescription = (couponsAppliedList: string) => {
  const appliedCouponArray = couponsAppliedList.split(',');
  const appliedCouponText = appliedCouponArray.join(', ');
  const couponCount = appliedCouponArray.length || 0;
  return couponCount > 2
    ? `${couponCount} ${COUPON_APPLIED_MSG}`
    : getAppliedCouponText(appliedCouponText);
};

export interface ActionDisabledParams {
  pageTypeOrOpenedFrom?: string;
  disablePriveProduct?: boolean;
  variantType?: string;
  productType?: string;
}

export const isActionDisabled = ({
  pageTypeOrOpenedFrom,
  disablePriveProduct,
  variantType,
  productType,
}: ActionDisabledParams) => {
  if (!pageTypeOrOpenedFrom) {
    return false;
  }
  switch (pageTypeOrOpenedFrom) {
    case PAGE_TYPES.SIZE_CHART:
    case PAGE_TYPES.ImageFullScreen:
    case PAGE_TYPES.VideoFullScreen:
    case PAGE_TYPES.all_shade:
      return disablePriveProduct;
    case PAGE_TYPES.All_Reviews_Page:
      // For Wishlist component
      if (variantType) {
        return false;
      }
      // For AddToCart component
      if (productType && isConfigurable(productType)) {
        return false;
      }
      return disablePriveProduct;
    default:
      return false;
  }
};

export const getUpdatedTrackingKeys = ({
  siteNavigation,
  siteSubNavigation,
  queryParams,
}: {
  siteNavigation: string;
  siteSubNavigation: string;
  queryParams: URLSearchParams;
}): UpdatedTrackingKeys => {
  const urlSiteNav = queryParams?.get(SITE_NAVIGATION_PARAM);
  const urlSiteSubNav = queryParams?.get(SITE_SUB_NAVIGATION_PARAM);

  if (!urlSiteNav || !urlSiteSubNav) {
    const pageSource = queryParams?.get(PAGE_SOURCE_PARAM);
    if (pageSource?.toLowerCase().startsWith(PRODUCT_WIDGET_VALUE)) {
      siteNavigation = PRODUCT_WIDGET_LABEL;
      siteSubNavigation = pageSource || siteSubNavigation;
    }
  }
  const result: UpdatedTrackingKeys = {
    updatedSiteNav: urlSiteNav || siteNavigation,
    updatedSiteSubNav: urlSiteSubNav || siteSubNavigation,
  };

  return result;
};

export const pushBuyNowClicked = (isBuyNowClicked: boolean) => {
  pushData({ isBuyNowClicked });
};

export const trackBuyNowCtaClicked = (data: BuyNowCtaClickedData) => {
  const buyNowTrackingData = {
    brandName: data.brandName,
    categoryL1Name: data.categoryL1Name,
    categoryL2Name: data.categoryL2Name,
    categoryL3Name: data.categoryL3Name,
    discountedPrice: data.discountedPrice,
    isLoggedIn: data.isLoggedIn,
    productId: data.productId,
    productName: data.productName,
    products: data.products,
    variantProductId: data.variantProductId,
    variantType: data.variantType,
  };
  pushEvent(TRACKING.BUY_NOW_CTA_CLICKED, { buyNowTrackingData });
};
